import React from 'react';

const Confluence = (props) => (
  <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 32 32"
    strokeWidth={2}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M9 3h10l6 6v18a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" strokeLinejoin="round" strokeLinecap="round" />
    <path d="M19 3v6h6" strokeLinejoin="round" strokeLinecap="round" />
    <path d="M11.5 16.5h9M11.5 21.5h9M11.5 26.5h5" strokeLinecap="round" />
  </svg>
);

export default Confluence;
